import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReceiveAttachmentsDialogComponent } from 'src/app/inventory/dialogs/receive-attachments-dialog/receive-attachments-dialog.component';
import { ButtonModule } from '../button/button.module';
import { DialogModule } from '../dialog/dialog.module';
import { DropdownWithOverlayOptionsListModule } from '../dropdown-with-overlay-options-list/dropdown-with-overlay-options-list.module';
import { FileUploaderModule } from '../file-uploader/file-uploader.module';
import { InputModule } from '../input/input.module';
import { FileAttachmentComponent } from './file-attachment.component';
import { GenericTableModule } from '../generic-table/generic-table.module';
import { FileExtensionPipe } from '../../pipes/file-extension/file-extension.pipe';
import { DotProgressIndicatorModule } from '../dot-progress-indicator/dot-progress-indicator.module';
import { SignaturePadModule } from '../signature-pad/signature-pad.module';
import { FileService } from '../../services/file-service';



@NgModule({
  declarations: [FileAttachmentComponent, ReceiveAttachmentsDialogComponent],
  imports: [
    CommonModule,
    ButtonModule,
    DialogModule,
    FileUploaderModule,
    FormsModule,
    InputModule,
    ScrollingModule,
    DropdownWithOverlayOptionsListModule,
    GenericTableModule,
    DotProgressIndicatorModule,
    SignaturePadModule,
    ReactiveFormsModule
  ],
  exports: [FileAttachmentComponent],
  providers: [FileExtensionPipe, FileService]
})
export class FileAttachmentModule { }
